module.exports = __webpack_public_path__ + "static/img/tkxc.6fb00cae.png";